<template>
  <div class="mb-4 booking-filters" v-if="activeOption != 'Path' && activeOption != 'NoService'">
    <div class="row">
      <div class="col-lg-3 relative">
        <b-form-group label="Ordenación de reservas">
          <b-form-select
            @input="orderBookings()"
            v-model="selected"
            :options="showSelectedOptions"
            class="custom-select"
            size="sm"
            style="width:100%"
          ></b-form-select>
        </b-form-group>
        <span v-if="isDataLoading" class="badge badge-danger my-2 badge-loading">
          <i class="fa fa-spinner fa-spin mx-2 my-1"></i>
          Petición en proceso... espere por favor
        </span>
      </div>
      <div class="col-lg-9">
        <b-form inline>
          <!-- <b-button size="sm" class="border" variant="light" @click="onBtnExpandedClickHandler">
            <i class="fa fa-caret-square-o-up"></i>
            <span class="ml-2">{{isBookingExpanded ? 'Plegar todo' : 'Desplegar todo'}}</span>
          </b-button> -->
          <div class="mx-4">
            <b-form-group label="Ver grupos (I)">
              <b-form-radio-group v-model="isBookingExpanded" id="radio-group-ver-plegado">
                <b-form-radio name="ver-plegado" :value="true">Desplegados</b-form-radio>
                <b-form-radio name="ver-plegado" :value="false">Plegados</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>
          <div class="mx-4" v-if="activeOption == 'Excursion' || activeOption == 'Pickup'">
            <b-form-group label="Ver buses">
              <b-form-radio-group v-model="showBuses" id="radio-group-ver-buses">  
                <b-form-radio name="ver-buses-todos" :value="false">Todos</b-form-radio>
                <b-form-radio name="ver-buses-abiertos" :value="true">Solo abiertos</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>
          <div class="mx-4" v-if="activeOption != 'Excursion' && activeOption != 'Pickup' ">
            <b-form-group label="Ver grupos (II)">
              <b-form-radio-group v-model="showUnassigned" id="radio-group-ver-reservas">
                <b-form-radio name="ver-reservas-opciones" :value="false">Todos</b-form-radio>
                <b-form-radio name="ver-reservas-opciones" :value="true">Solo pendientes</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>
          <div class="mx-4" v-if="activeOption == 'Activity' || activeOption == 'Stop'">
            <b-form-group label="Ver reservas">
              <b-form-radio-group v-model="showIndividualBookingsUnassigned" id="radio-group-show-individual-bookings-unassigned">
                <b-form-radio name="ver-reservas-all" :value="false">Todas</b-form-radio>
                <b-form-radio name="ver-reservas-unassigned" :value="true">Solo sin asignar</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>

          <div class="mx-4" v-if="activeOption == 'Stop'">
            <b-form-group label="Orden paradas">
              <b-form-radio-group v-model="sortByStopMode" id="radio-group-order-paradas">
                <b-form-radio name="ver-reservas-paradas" :value="true">Andratx -> Arenal</b-form-radio>
                <b-form-radio name="ver-reservas-paradas" :value="false">Arenal -> Andratx</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>

          <div class="mx-4" v-if="activeOption == 'Activity'">
            <b-form-group label="Agrupaciones">
              <b-form-radio-group v-model="groupingGroups" id="radio-group-order-paradas">
                <b-form-radio name="ver-agrupaciones" :value="'common_id'">No</b-form-radio>
                <b-form-radio name="ver-agrupaciones" :value="'tag'">Sí</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>

        </b-form>
      </div>
    </div>
    <div class="row" v-if="((activeTab == 'Excursions' && activeOption == 'Activity'))">
      <div class="col-lg-9">
        <b-form-group label="Seleccionar actividad">
          <b-form-select
            v-model="filterGroupSelection"
            :options="filterSelectionOptions"
            class="custom-select"
            size="sm"
            style="width:: 100%;"
          ></b-form-select>
        </b-form-group>
      </div>
    </div>

    <div class="row" v-if="(activeTab == 'Returns' && activeOption == 'Stop') || (activeTab == 'Pickups' && activeOption == 'Stop')">
      <div class="col-lg-9">
        <b-form-group label="Seleccionar actividad">
          <b-form-select
            v-model="filterActivity"
            :options="filterActivityOptions"
            class="custom-select"
            size="sm"
            style="width:: 100%;"
          ></b-form-select>
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { EventBus } from "../../../../EventBus";
import { mapGetters } from "vuex";

export default {
  props: [
    "changeParentProperty",
    "reservas",
    "path",
  ],
  data() {
    return {
      selected: null, 
      showUnassigned: false,
      sortByStopMode: true,
      showIndividualBookingsUnassigned: false,
      isBookingExpanded: true,
      showBuses: false,
      options: [
        { value: null, text: "Ordenar por...", inTabs: ['Excursions', 'Pickups'], inOptions: ['Activity', 'Excursion', 'Stop', 'Pickup'] },
        { value: "customer_language", text: "Idioma ASC", inTabs: ['Excursions', 'Pickups'], inOptions: ['Activity', 'Excursion', 'Stop', 'Pickup'] },
        { value: "-customer_language", text: "Idioma DESC", inTabs: ['Excursions', 'Pickups'], inOptions: ['Activity', 'Excursion', 'Stop', 'Pickup'] },
        { value: "agency", text: "Punto venta ASC", inTabs: ['Excursions', 'Pickups'], inOptions: ['Activity', 'Excursion', 'Stop', 'Pickup'] },
        { value: "-agency", text: "Punto venta DESC", inTabs: ['Excursions', 'Pickups'], inOptions: ['Activity', 'Excursion', 'Stop', 'Pickup'] },
        // order by stop ordering on excursion
        { value: "booking__order_1", text: "Parada ASC", inTabs: ['Excursions', 'Pickups'], inOptions: ['Activity', 'Excursion'] },
        { value: "-booking__order_1", text: "Parada DESC", inTabs: ['Excursions', 'Pickups'], inOptions: ['Activity', 'Excursion'] },
        { value: "booking__order_1,customer_language", text: "Parada ASC + idioma agrupado", inTabs: ['Excursions', 'Pickups'], inOptions: ['Activity', 'Excursion']},
        { value: "-booking__order_1,customer_language", text: "Parada DESC + idioma agrupado", inTabs: ['Excursions', 'Pickups'], inOptions: ['Activity', 'Excursion']},
        // order by stop ordering on pickups
        { value: "booking__order", text: "Parada ASC", inTabs: ['Pickups'], inOptions: ['Pickup'] },
        { value: "-booking__order", text: "Parada DESC", inTabs: ['Pickups'], inOptions: ['Pickup'] },
        { value: "booking__order,customer_language", text: "Parada ASC + idioma agrupado", inTabs: ['Pickups'], inOptions: ['Pickup']},
        { value: "-booking__order,customer_language", text: "Parada DESC + idioma agrupado", inTabs: ['Pickups'], inOptions: ['Pickup']},
        //{ value: "manual", text: "Orden manual", inTabs: ['Excursions', 'Pickups'], inOptions: ['Excursion']},
      ],
      filterGroupSelection: 0,
      groupingGroups: 'common_id',
      filterActivity: "0"
    };
  },
  mounted() {
    //EventBus.$on('optionChanged', this.onOptionChanged.bind(this))
    if ( this.activeTab == 'Excursions' && this.activeOption == 'Activity' )
      this.selected = 'booking__order_1'
    else
      this.selected = null
  },
  methods: {
    onBtnExpandedClickHandler() {
      //this.isBookingExpanded = !this.isBookingExpanded;
      this.changeParentProperty("isBookingExpanded", this.isBookingExpanded);
    },
    onBtnShowUnassignedClickHandler() {
      //this.showUnassigned = !this.showUnassigned;
      this.changeParentProperty("showUnassigned", this.showUnassigned);
    },
    onBtnShowIndividualBookingsUnassignedHandler() {
      this.changeParentProperty("showIndividualBookingsUnassigned", this.showIndividualBookingsUnassigned);
    },
    onBtnShowBusesHandler() {
      this.changeParentProperty("showBuses", this.showBuses)
    },
    onBtnFilterGroupSelectionHandler() {
      this.changeParentProperty("showFilteringActivityGroup", this.filterGroupSelection)
    },
    onBtnGroupingGroupsHandler() {
      this.changeParentProperty("groupingGroups", this.groupingGroups)
    },
    onBtnFilterActivityHandler() {
      this.changeParentProperty("filterActivity", this.filterActivity)
    },
    orderBookings() {
      let bus_type =  "Excursion"
      if ( this.activeTab == "Pickups" )
        bus_type = "Pickup"
      if ( this.activeTab == "Returns" ) {
        bus_type = "Return"
      }
      let bookingData = {
        date: this.$store.getters.filterDate,
        group: this.$store.getters.filterGroup,
        order_by: this.selected, // TODO: go to store
        bus_type: bus_type,
        distinct_key: this.groupingGroups != null && this.groupingGroups == 'tag' ? 'tag' : null
      };

      const bookingStopData = {
        date: this.$store.getters.filterDate,
        group: this.$store.getters.filterGroup,
        order_by: this.selected,
        order: !this.sortByStopMode ? "&order_stop=-order" : "&order_stop=order",
        bus_type: 'Excursion',
        common_id: this.filterActivity
      };

    
      if (this.activeOption == "Activity") {
        console.log('activity ordered', bookingData)
        this.$store.dispatch(
          "bookings/loadBookingsByActivityOrdered",
          bookingData
        );
      }
      if (this.selected != null) {
        if (this.activeOption == "Excursion") {
          bookingData.bus_type = 'Excursion'
          this.$store.dispatch(
            "bookings/loadBookingsByBusOrdered",
            bookingData
          );
        }
        if ( this.activeOption == "Pickup" ) {
          this.$store.dispatch(
            "bookings/loadBookingsByBusOrdered",
            bookingData
          );
        }
        if (this.activeOption == "Stop") {

          this.$store.dispatch(
            "bookings/loadBookingsByStopOrdered",
            bookingStopData
          );
        }
      }
      console.log('order bookings')
      
    },
    sortBookingsByStop() {
      if (!this.sortByStopMode) {
        const payload = {
          order: "&order_stop=-order"
        };
        this.$store.dispatch("bookings/loadBookingsByStop", payload);
        //this.sortByStopMode = true;
      } else {
        const payload = {
          order: "&order_stop=order"
        };
        this.$store.dispatch("bookings/loadBookingsByStop", payload);
        //this.sortByStopMode = false;
      }
    },
    onOptionChanged() {
      
    }
  },
  computed: {
    ...mapGetters(["activeOption"]),
    ...mapGetters(['activeTab']),
    ...mapGetters(['isDataLoading']),
    showSelectedOptions() {
      return this.options.filter(option => option.inOptions.includes(this.activeOption))
      //return this.activeOption == 'Stop' ? this.options.filter(option => (option.value == null || !option.value.includes('stopschedule'))) : this.options
    },
    filterSelectionOptions() {
      let options = []
      options.push({
        value: 0,
        text: 'Mostrar todas'
      })
      if ( this.reservas != null ) {
        const available = this.reservas.map( (item) => ({
          value: item.id,
          text: item.name
        }))
        console.log("available", available)
        options = options.concat(available)
      }
      
      return options
    },
    filterActivityOptions() {
      let options = []
      options.push({
        value: "0",
        text: 'Mostrar todo'
      })
      if ( this.reservas != null ) {
        console.log('this.reservas', this.reservas)
        const available = new Map(this.reservas.map( (item) => (item.bookings_list) ).flat(1).map((booking) => [booking.common_id, booking]));
        const uniques = [...available.values()];
        console.log('uniques', uniques)
        const rest = uniques.map( (entry) => ({
          value: entry.common_id,
          text: entry.trekksoft_activity_name
        }))
        console.log('rest', rest)
        // let available = this.reservas.map( (item) => (item.bookings_list) ).flat(1).map( (booking) => ({
        //   value: booking.common_id,
        //   text: booking.trekksoft_activity_name
        // }))
        // available = Array.from( new Set( available ) )
        options = options.concat(rest)
      }
      return options
    }
  },
  watch: {
    showUnassigned: function() {
      this.onBtnShowUnassignedClickHandler()
    },
    sortByStopMode: function() {
      this.sortBookingsByStop()
    },
    isBookingExpanded: function() {
      this.onBtnExpandedClickHandler()
    },
    showIndividualBookingsUnassigned: function() {
      this.onBtnShowIndividualBookingsUnassignedHandler()
    },
    showBuses: function() {
      this.onBtnShowBusesHandler()
    },
    filterGroupSelection: function() {
      this.onBtnFilterGroupSelectionHandler()
    },
    groupingGroups: function() {
      this.onBtnGroupingGroupsHandler()
      this.orderBookings()
    },
    filterActivity: function() {
      this.onBtnFilterActivityHandler()
      this.orderBookings()
    },


    activeOption: function() {
      this.showUnassigned = false
      this.sortByStopMode = true
      this.showIndividualBookingsUnassigned = false
      this.isBookingExpanded = true
      this.showBuses = false
      this.filterGroupSelection = 0
      this.groupingGroups = 'common_id'
      this.filterActivity = "0"
    }
  }
};
</script>

<style scoped>
.badge-loading {
  padding: 5px 10px;
  margin-left: 10px;
  position: fixed;
  bottom: 0;
  left: 0;
  color: white;
}
</style>